import React, { useEffect, useState } from 'react';
import { MultiplierBreakdown } from '../types/game';

interface MultiplierPopupProps {
  breakdown: MultiplierBreakdown | null;
  show: boolean;
}

const MultiplierPopup: React.FC<MultiplierPopupProps> = ({ breakdown, show }) => {
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    if (show && breakdown) {
      setVisible(true);
      const timer = setTimeout(() => setVisible(false), 1500);
      return () => clearTimeout(timer);
    }
  }, [show, breakdown]);

  if (!visible || !breakdown) return null;

  const parts: string[] = [];
  if (breakdown.speedMultiplier > 1) parts.push(`speed ${breakdown.speedMultiplier}x`);
  if (breakdown.streakMultiplier > 1) parts.push(`streak ${breakdown.streakMultiplier}x`);
  if (breakdown.tierMultiplier > 1) parts.push(`tier ${breakdown.tierMultiplier}x`);

  return (
    <div className="multiplier-popup multiplier-pop-in">
      <span className="multiplier-points">+{breakdown.total} pts</span>
      {parts.length > 0 && (
        <span className="multiplier-detail">{parts.join(' \u00B7 ')}</span>
      )}
    </div>
  );
};

export default MultiplierPopup;
